//
//  DocumentationLegacyPageBlockEmbedFigma.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlockEmbedGeneric, } from "./SDKDocumentationLegacyPageBlockEmbedGeneric";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockEmbedFigma extends DocumentationLegacyPageBlockEmbedGeneric {
}
